import type { NavigationGuard } from "vue-router";

import { useUserStore } from "@/stores";

export function searchViewTypeGuard(): NavigationGuard {
  return async (to) => {
    if (!to.meta.searchViewType) {
      return;
    }

    const userStore = useUserStore();
    const { featureFlags } = await userStore.getUser();

    if (featureFlags.availableSearchViews.includes(to.meta.searchViewType)) {
      return;
    }

    const availableSearchViewType = featureFlags.availableSearchViews[0];
    return { ...to, name: `search.${availableSearchViewType}` };
  };
}
